"use strict";

define('rs/models/user',['rs/models/abstract', 'rs/models/session', 'rs/helper', 'rs/models/tenant', 'rs/models/person', 'rs/errors'], function (AbstractModel, Session, helper, Tenant, Person, RSErrors) {
  var UserModel = AbstractModel.extend({
    properties: ['id', 'userName', 'firstName', 'lastName', 'personId', 'person', 'personEmail', 'lastLogonDate', 'firstLogonDate', 'activityDate', 'version', 'redirectPath', 'associatedTenant', 'wootricCode'],
    logout: function logout() {
      return this.constructor.requestLogout();
    },
    getDisplayName: function getDisplayName() {
      if (this.firstName || this.lastName) {
        return (this.getFirstName() + " " + this.getLastName()).trim();
      } else {
        return this.getUserName();
      }
    },
    isIRBMember: function isIRBMember() {
      return this.hasRole(UserModel.Roles.IRB_MEMBER);
    },
    getUsername: function getUsername() {
      return this.getUserName();
    },
    getUserLogin: function getUserLogin() {
      return this.getUsername() + '@' + this.getAssociatedTenant().id;
    }
  }, {
    rootURI: '/rs/',
    parsers: {
      'public/login': function public_login(data) {
        data.username = data.name;
        return this.model(data);
      }
    },
    setup: function setup() {
      var that = this;
      return Session.requestToken().then(function () {
        Session.triggerUIActivity();
        return Session.doHeartbeat({
          silent: true
        });
      }).then(function (heartbeat) {
        var response = heartbeat.get('response');
        if (response == 'NO_SESSION' || response == 'LOGOUT') {
          throw new RSErrors.NoSessionError();
        }
        return that.requestSession();
      });
    },
    requestLogin: function requestLogin(username, password) {
      var data = {
          username: username,
          password: password
        },
        that = this;
      data['_csrf'] = Session.getToken();
      return this.post('public/login', data).then(function () {
        return that.setup();
      });
    },
    requestLogout: function requestLogout() {
      var data = {};
      data['_csrf'] = Session.getToken();
      return this.post('public/logout', data).caught(function () {});
    },
    requestSession: function requestSession() {
      var that = this,
        user = null;
      return Session.requestSessionInfo().then(function (data) {
        var tenant = Tenant.model(data.tenant);
        if (!data.user.person) {
          data.user.person = {
            id: data.user.personId
          };
        }
        data.user.person = new Person(data.user.person);
        data.user.person.loadAuthorities(data.authentication.authorities);
        data.user.authorities = data.authentication.authorities;
        data.user.person.setFeatures(data.features);
        data.user.features = data.features;
        user = that.model(data.user);
        user.setWootricCode(data.wootricCode);
        user.setRedirectPath(data.logoutDestination);
        user.setAssociatedTenant(tenant);
        if (!user.authId) {}
        return user;
      });
    },
    doesEmailExist: function doesEmailExist(email) {
      return this.get('../libs/researchsuite/stubs/user.emailexist.json');
    },
    doesUserWithEmailExist: function doesUserWithEmailExist(email, username) {
      return this.get('../libs/researchsuite/stubs/user.emailexist.json');
    },
    verifyPasswordReset: function verifyPasswordReset(userId, hash) {
      return this.get('../libs/researchsuite/stubs/user.emailexist.json');
    },
    resetPassword: function resetPassword(userId, hash, password) {
      return this.get('../libs/researchsuite/stubs/user.emailexist.json');
    }
  });
  return UserModel;
});

